import { IntlProvider } from "use-intl";
import Header from "./Header";
import { HeaderProps } from "./types";
import StoreProvider from "./store/provider";
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { State } from "./store/type";
import { initialState } from "./store/context";
import Cookies from "js-cookie";
import { Languages, LanguagesType } from "../types";
import { BUITheme, NoticeProvider } from "@blofin/blofin-ui";
import { updateUserInfo } from "../common/CustomEvent";

const HeaderWrapper: ForwardRefRenderFunction<
  { updateTheme: (theme: BUITheme) => void },
  HeaderProps
> = (
  {
    hideSignUpAndLogIn = false,
    showTheme = false,
    changeTheme,
    position = "sticky",
    baseUrl,
    theme,
    themeLock,
    locale,
    hideAcitvityLogo = false,
    customChangeLang,
    isDemoTrading = false,
    hideAllMenus,
    wrapperClass,
    env
  },
  ref
) => {
  useImperativeHandle(ref, () => ({
    updateTheme: (theme: BUITheme) => {
      setState((state) => {
        return {
          ...state,
          theme: theme,
          isSticky: window.scrollY > 0
        };
      });
    }
  }));

  const [state, setState] = useState<State>({
    ...initialState,
    hideSignUpAndLogIn: hideSignUpAndLogIn,
    showTheme: showTheme,
    changeTheme: changeTheme,
    position: position,
    theme: position === "sticky" ? (theme ? theme : "dark") : theme ? theme : "light",
    baseUrl: baseUrl || "",
    defaultTheme: theme,
    themeLock: themeLock,
    locale: locale as any,
    hideAcitvityLogo: hideAcitvityLogo,
    isDemoTrading: isDemoTrading,
    hideAllMenus: hideAllMenus,
    env: env
  });

  useEffect(() => {
    const existingUserInfo = window.userInfo;

    Object.defineProperty(window, "userInfo", {
      configurable: true,
      enumerable: true,
      get: function () {
        return this._userInfo || null;
      },
      set: function (value) {
        this._userInfo = value;
        updateUserInfo(value);
        setState((prevState) => ({
          ...prevState,
          userInfo: value,
          isLogin: value?.uid ? true : false,
          isSticky: window.scrollY > 0
        }));
      }
    });

    if (existingUserInfo) {
      window.userInfo = existingUserInfo;
    }

    return () => {
      Object.defineProperty(window, "userInfo", {
        configurable: true,
        enumerable: true,
        value: null,
        writable: true
      });
    };
  }, []);

  // 会触发更新
  useEffect(() => {
    const locale = window?.next?.router?.state?.locale || "en";

    const isDemoTrading = Cookies.get("Global-UserViewType") === "demo-trading";
    setState((state) => ({
      ...state,
      theme: position === "sticky" ? (theme ? theme : "dark") : theme ? theme : "light",
      locale: locale as LanguagesType,
      localeLink: locale === "en" ? "" : "/" + locale,
      isDemoTrading: isDemoTrading,
      isSticky: window.scrollY > 0
    }));
  }, [theme]);

  return (
    <NoticeProvider>
      <StoreProvider value={state}>
        <IntlProvider locale={state.locale} messages={Languages[state.locale as LanguagesType]}>
          <Header customChangeLang={customChangeLang} wrapperClass={wrapperClass} />
        </IntlProvider>
      </StoreProvider>
    </NoticeProvider>
  );
};

export default forwardRef(HeaderWrapper);
